// src/shared/constants/townNames.js

export const ALL_TOWNS = [
"Andover",
"Ansonia",
"Ashford",
"Avon",
"Barkhamsted",
"Beacon Falls",
"Berlin",
"Bethany",
"Bethel",
"Bethlehem",
"Bloomfield",
"Bolton",
"Bozrah",
"Branford",
"Bridgeport",
"Bridgewater",
"Bristol",
"Brookfield",
"Brooklyn",
"Burlington",
"Canaan",
"Canterbury",
"Canton",
"Chaplin",
"Cheshire",
"Chester",
"Clinton",
"Colchester",
"Colebrook",
"Columbia",
"Cornwall",
"Coventry",
"Cromwell",
"Danbury",
"Darien",
"Deep River",
"Derby",
"Durham",
"East Granby",
"East Haddam",
"East Hampton",
"East Hartford",
"East Haven",
"East Lyme",
"East Windsor",
"Eastford",
"Easton",
"Ellington",
"Enfield",
"Essex",
"Fairfield",
"Farmington",
"Franklin",
"Glastonbury",
"Goshen",
"Granby",
"Greenwich",
"Griswold",
"Groton",
"Guilford",
"Haddam",
"Hamden",
"Hampton",
"Hartford",
"Hartland",
"Harwinton",
"Hebron",
"Kent",
"Killingly",
"Killingworth",
"Lebanon",
"Ledyard",
"Lisbon",
"Litchfield",
"Lyme",
"Madison",
"Manchester",
"Mansfield",
"Marlborough",
"Meriden",
"Middlebury",
"Middlefield",
"Middletown",
"Milford",
"Monroe",
"Montville",
"Morris",
"Naugatuck",
"Newington",
"Newtown",
"New Britain",
"New Canaan",
"New Fairfield",
"New Hartford",
"New Haven",
"New London",
"New Milford",
"Norfolk",
"North Branford",
"North Canaan",
"North Haven",
"North Stonington",
"Norwalk",
"Norwich",
"Old Lyme",
"Old Saybrook",
"Orange",
"Oxford",
"Plainfield",
"Plainville",
"Plymouth",
"Pomfret",
"Portland",
"Preston",
"Prospect",
"Putnam",
"Redding",
"Ridgefield",
"Rocky Hill",
"Roxbury",
"Salem",
"Salisbury",
"Scotland",
"Seymour",
"Sharon",
"Shelton",
"Sherman",
"Simsbury",
"Somers",
"South Windsor",
"Southbury",
"Southington",
"Sprague",
"Stafford",
"Stamford",
"Sterling",
"Stonington",
"Stratford",
"Suffield",
"Thomaston",
"Thompson",
"Tolland",
"Torrington",
"Trumbull",
"Union",
"Vernon",
"Voluntown",
"Wallingford",
"Warren",
"Washington",
"Waterbury",
"Waterford",
"Watertown",
"West Hartford",
"West Haven",
"Westbrook",
"Weston",
"Westport",
"Wethersfield",
"Willington",
"Wilton",
"Winchester",
"Windham",
"Windsor",
"Windsor Locks",
"Wolcott",
"Woodbridge",
"Woodbury",
"Woodstock"
];

export const TOWN_SEEC_ORGANIZATIONS = {
  // __SEEC_ORGS_START__
  "Andover": [
    "Andover Democratic Town Committee",
    "Andover Republican Town Committee"
  ],
  "Ansonia": [
    "Ansonia Democratic Town Committee",
    "Ansonia Republican Town Committee"
  ],
  "Ashford": [
    "Ashford Democratic Town Committee",
    "Ashford Republican Town Committee"
  ],
  "Avon": [
    "Avon Democratic Town Committee",
    "Avon Republican Town Committee"
  ],
  "Barkhamsted": [
    "Barkhamsted Democratic Town Committee",
    "Barkhamsted Republican Town Committee"
  ],
  "Beacon Falls": [
    "Beacon Falls Democratic Town Committee",
    "Beacon Falls Republican Town Committee"
  ],
  "Berlin": [
    "Berlin Democratic Town Committee",
    "Berlin Republican Town Committee"
  ],
  "Bethany": [
    "Bethany Democratic Town Committee",
    "Bethany Republican Town Committee"
  ],
  "Bethel": [
    "Bethel Democratic Town Committee",
    "Bethel Republican Town Committee"
  ],
  "Bethlehem": [
    "Bethlehem Democratic Town Committee",
    "Bethlehem Republican Town Committee"
  ],
  "Bloomfield": [
    "Bloomfield Black Democratic Club PAC",
    "Bloomfield Democratic Town Committee",
    "Bloomfield Republican Town Committee"
  ],
  "Bolton": [
    "Bolton Democratic Town Committee",
    "Bolton for Westport",
    "Bolton Republican Town Committee"
  ],
  "Bozrah": [
    "Bozrah Democratic Town Committee",
    "Bozrah Republican Town Committee"
  ],
  "Branford": [
    "Branford Democratic Town Committee",
    "Branford Education Association PAC",
    "Branford Republican Town Committee"
  ],
  "Bridgeport": [
    "Bridgeport 2012 Shining New Alliance",
    "Bridgeport Coalition For Change",
    "Bridgeport Democratic Town Committee",
    "Bridgeport Federation Of Democratic Women",
    "Bridgeport Independent Party Town Committee",
    "Bridgeport New Democrats",
    "Bridgeport Now",
    "Bridgeport Republican Town Committee",
    "Bridgeport Working Families Town Committee"
  ],
  "Bridgewater": [
    "Bridgewater Democratic Town Committee",
    "Bridgewater Republican Town Committee"
  ],
  "Bristol": [
    "Bristol Democratic Town Committee",
    "Bristol Federation Of Teachers-Committee On Political Educat",
    "Bristol Republican Council District 1",
    "Bristol Republican Town Committee"
  ],
  "Brookfield": [
    "Brookfield Democratic Town Committee",
    "Brookfield Republican Town Committee"
  ],
  "Brooklyn": [
    "Brooklyn Democratic Town Committee",
    "Brooklyn Republican Town Committee"
  ],
  "Burlington": [
    "Burlington Democratic Town Committee",
    "Burlington Republican Town Committee"
  ],
  "Canaan": [
    "Canaan Democratic Town Committee",
    "Canaan Republican Town Committee"
  ],
  "Canterbury": [
    "Canterbury Democratic Town Committee",
    "Canterbury First",
    "Canterbury Republican Town Committee"
  ],
  "Canton": [
    "Canton Democratic Town Committee",
    "Canton Republican Town Committee"
  ],
  "Chaplin": [
    "Chaplin Democratic Town Committee",
    "Chaplin Republican Town Committee"
  ],
  "Cheshire": [
    "Cheshire Democratic Town Committee",
    "Cheshire Democratic Women's Club",
    "Cheshire Republican Town Committee"
  ],
  "Chester": [
    "Chester Democratic Town Committee",
    "Chester Republican Town Committee"
  ],
  "Clinton": [
    "Clinton Democratic Town Committee",
    "Clinton First",
    "Clinton Republican Town Committee"
  ],
  "Colchester": [
    "Colchester Democratic Town Committee",
    "Colchester Democratic Women's Club",
    "Colchester Independent Party 2017",
    "Colchester Republican Town Committee",
    "Colchester Solutions Together"
  ],
  "Colebrook": [
    "Colebrook Democratic Town Committee",
    "Colebrook Republican Town Committee"
  ],
  "Columbia": [
    "Columbia Democratic Town Committee",
    "Columbia Republican Town Committee"
  ],
  "Cornwall": [
    "Cornwall Democratic Town Committee",
    "Cornwall Republican Town Committee"
  ],
  "Coventry": [
    "Coventry Democratic Town Committee",
    "Coventry Republican Town Committee"
  ],
  "Cromwell": [
    "Cromwell Democratic Town Committee",
    "Cromwell Republican Town Committee"
  ],
  "Danbury": [
    "Danbury Central Labor Council PAC",
    "Danbury Democratic Town Committee",
    "Danbury Republican PAC",
    "Danbury Republican Town Committee"
  ],
  "Darien": [
    "Darien Democratic Town Committee",
    "Darien Republican Town Committee"
  ],
  "Deep River": [
    "Deep River Democratic Town Committee",
    "Deep River Independent Town Committee",
    "Deep River Republican Town Committee"
  ],
  "Derby": [
    "Derby Democratic Town Committee",
    "Derby Republican Town Committee"
  ],
  "Durham": [
    "Durham Democratic Town Committee",
    "Durham Democratic Women's Club",
    "Durham Republican Town Committee"
  ],
  "East Granby": [
    "East Granby Democratic Town Committee",
    "East Granby Republican Town Committee"
  ],
  "East Haddam": [
    "East Haddam Democratic Town Committee",
    "East Haddam Republican Town Committee"
  ],
  "East Hampton": [
    "East Hampton Democratic Town Committee",
    "East Hampton Republican Town Committee"
  ],
  "East Hartford": [
    "East Hartford 2nd District Democrats",
    "East Hartford Black Caucus",
    "East Hartford Democratic Town Committee",
    "East Hartford Republican Town Committee"
  ],
  "East Haven": [
    "East Haven Democratic Town Committee",
    "East Haven Republican Town Committee"
  ],
  "East Lyme": [
    "East Lyme Democratic Town Committee",
    "East Lyme Republican Town Committee"
  ],
  "East Windsor": [
    "East Windsor Democratic Town Committee",
    "East Windsor Republican Town Committee"
  ],
  "Eastford": [
    "Eastford Democratic Town Committee",
    "Eastford Republican Town Committee"
  ],
  "Easton": [
    "Easton Democratic Town Committee",
    "Easton Republican Town Committee"
  ],
  "Ellington": [
    "Ellington Democratic Town Committee",
    "Ellington Republican Town Committee"
  ],
  "Enfield": [
    "Enfield Democratic Town Committee",
    "Enfield Republican Town Committee",
    "Enfield Teachers Association PAC"
  ],
  "Essex": [
    "Essex Democratic Town Committee",
    "Essex Republican Town Committee"
  ],
  "Fairfield": [
    "Fairfield County Labor Council",
    "Fairfield County Young Democrats",
    "Fairfield Democratic Town Committee",
    "Fairfield Firefighters Local 1426 PAC",
    "Fairfield First",
    "Fairfield First Political Action Committee",
    "Fairfield Republican Town Committee"
  ],
  "Farmington": [
    "Farmington Democratic Town Committee",
    "Farmington Republican Town Committee"
  ],
  "Franklin": [
    "Franklin Democratic Town Committee",
    "Franklin Republican Town Committee"
  ],
  "Glastonbury": [
    "Glastonbury Democratic Federated Women's Club",
    "Glastonbury Democratic Town Committee",
    "Glastonbury Republican Town Committee"
  ],
  "Goshen": [
    "Goshen Democratic Town Committee",
    "Goshen Republican Town Committee"
  ],
  "Granby": [
    "Granby Democratic Town Committee",
    "Granby Republican Town Committee"
  ],
  "Greenwich": [
    "Greenwich Democratic Town Committee",
    "Greenwich Republican Town Committee"
  ],
  "Griswold": [
    "Griswold Democratic Town Committee",
    "Griswold Republican Town Committee"
  ],
  "Groton": [
    "Groton City Democratic Committee",
    "Groton City Republican Committee",
    "Groton Democratic Town Committee",
    "Groton Federation Of Democratic Women",
    "Groton Good Government PAC",
    "Groton Independents",
    "Groton Initiative",
    "Groton Republican Town Committee"
  ],
  "Guilford": [
    "Guilford Democratic Town Committee",
    "Guilford Parents & Citizens Together",
    "Guilford Republican Town Committee"
  ],
  "Haddam": [
    "Haddam Democratic Town Committee",
    "Haddam Republican Town Committee"
  ],
  "Hamden": [
    "Hamden Action Now Political Action Committee",
    "Hamden Democratic Town Committee",
    "Hamden Education Association Political Action Committee",
    "Hamden Republican Town Committee"
  ],
  "Hampton": [
    "Hampton 2012",
    "Hampton 2014",
    "Hampton 2016",
    "Hampton 2018",
    "Hampton 2020",
    "Hampton 2022",
    "Hampton Democratic Town Committee",
    "Hampton Republican Town Committee"
  ],
  "Hartford": [
    "Hartford Democratic Town Committee",
    "Hartford Democratic Women United",
    "Hartford Federation Of Teachers",
    "Hartford Fire PAC",
    "Hartford For Mccauley",
    "Hartford Neighborhood Democrats",
    "Hartford Republican Town Committee",
    "Hartford Working Families Town Committee"
  ],
  "Hartland": [
    "Hartland Democratic Town Committee",
    "Hartland Republican Town Committee"
  ],
  "Harwinton": [
    "Harwinton Democratic Town Committee",
    "Harwinton Republican Town Committee"
  ],
  "Hebron": [
    "Hebron Democratic Town Committee",
    "Hebron Republican Town Committee"
  ],
  "Kent": [
    "Kent Democratic Town Committee",
    "Kent Johnson Libertarian 2018",
    "Kent Republican Town Committee"
  ],
  "Killingly": [
    "Killingly Democratic Town Committee",
    "Killingly Republican Town Committee"
  ],
  "Killingworth": [
    "Killingworth Conservative",
    "Killingworth Democratic Town Committee",
    "Killingworth Republican Town Committee"
  ],
  "Lebanon": [
    "Lebanon Democratic Town Committee",
    "Lebanon Republican Town Committee"
  ],
  "Ledyard": [
    "Ledyard Democratic Town Committee",
    "Ledyard Republican Town Committee"
  ],
  "Lisbon": [
    "Lisbon Democratic Town Committee",
    "Lisbon Republican Town Committee"
  ],
  "Litchfield": [
    "Litchfield Democratic Town Committee",
    "Litchfield Republican Town Committee"
  ],
  "Lyme": [
    "Lyme Democratic Town Committee",
    "Lyme Republican Town Committee"
  ],
  "Madison": [
    "Madison Democratic Town Committee",
    "Madison Republican Town Committee"
  ],
  "Manchester": [
    "Manchester Democratic Town Committee",
    "Manchester Police Union #1495",
    "Manchester Republican Town Committee",
    "Manchester Republican Women's Club"
  ],
  "Mansfield": [
    "Mansfield Democratic Town Committee",
    "Mansfield Republican Town Committee"
  ],
  "Marlborough": [
    "Marlborough Democratic Town Committee",
    "Marlborough Republican Town Committee"
  ],
  "Meriden": [
    "Meriden Democratic Town Committee",
    "Meriden Federation Of Teachers Committee On Political Ed",
    "Meriden Firefighters Local 1148 PAC",
    "Meriden Republican Town Committee"
  ],
  "Middlebury": [
    "Middlebury Democratic Town Committee",
    "Middlebury Republican Town Committee"
  ],
  "Middlefield": [
    "Middlefield Democratic Town Committee",
    "Middlefield Republican Town Committee"
  ],
  "Middletown": [
    "Middletown Democratic Town Committee",
    "Middletown Democrats 2017",
    "Middletown Republican Town Committee",
    "Middletown Teachers Election Committee",
    "Middletown Young Democrats"
  ],
  "Milford": [
    "Milford Democratic Town Committee",
    "Milford Professional Firefighters PAC Fund",
    "Milford Republican Town Committee"
  ],
  "Monroe": [
    "Monroe Democratic Town Committee",
    "Monroe Republican Town Committee"
  ],
  "Montville": [
    "Montville Democratic Town Committee",
    "Montville Republican Town Committee"
  ],
  "Morris": [
    "Morris Democratic Town Committee",
    "Morris Is For Us",
    "Morris Is For Us 2008",
    "Morris Republican Town Committee",
    "Morrison for CT"
  ],
  "Naugatuck": [
    "Naugatuck Democratic Town Committee",
    "Naugatuck Republican Town Committee",
    "Naugatuck Valley Young Democrats"
  ],
  "New Britain": [
    "New Britain Democratic Town Committee",
    "New Britain Republican Town Committee",
    "New Britain's Future"
  ],
  "New Canaan": [
    "New Canaan Democratic Town Committee",
    "New Canaan Republican Town Committee"
  ],
  "New Fairfield": [
    "New Fairfield Democratic Town Committee",
    "New Fairfield Republican Town Committee"
  ],
  "New Hartford": [
    "New Hartford Democratic Town Committee",
    "New Hartford Republican Town Committee"
  ],
  "New Haven": [
    "New Haven Central Labor Council PAC",
    "New Haven Democratic Town Committee",
    "New Haven Fire Fighters Committee",
    "New Haven Green Party",
    "New Haven Republican Town Committee"
  ],
  "New London": [
    "New London Democratic Town Committee",
    "New London First 2014",
    "New London Greens",
    "New London Republican Town Committee",
    "New London Working Families Town Committee"
  ],
  "New Milford": [
    "New Milford Democratic Town Committee",
    "New Milford Republican Town Committee"
  ],
  "Newington": [
    "Newington Democratic Town Committee",
    "Newington Republican Town Committee"
  ],
  "Newtown": [
    "Newtown Democratic Town Committee",
    "Newtown Forward Town Committee",
    "Newtown Republican Town Committee"
  ],
  "Norfolk": [
    "Norfolk Democratic Town Committee",
    "Norfolk Republican Town Committee"
  ],
  "North Branford": [
    "North Branford Democratic Town Committee",
    "North Branford Republican Town Committee"
  ],
  "North Canaan": [
    "North Canaan Democratic Town Committee",
    "North Canaan Republican Town Committee"
  ],
  "North Haven": [
    "North Haven Democratic Town Committee",
    "North Haven Republican Town Committee"
  ],
  "North Stonington": [
    "North Stonington Democratic Town Committee",
    "North Stonington Republican Town Committee"
  ],
  "Norwalk": [
    "Norwalk Democratic Town Committee",
    "Norwalk District E Democratic Committee",
    "Norwalk Republican Town Committee"
  ],
  "Norwich": [
    "Norwich Democratic Town Committee",
    "Norwich Fire Fighters P.A.C.",
    "Norwich For Change Political Action Committee",
    "Norwich Republican Town Committee"
  ],
  "Old Lyme": [
    "Old Lyme Democratic Town Committee",
    "Old Lyme Republican Town Committee"
  ],
  "Old Saybrook": [
    "Old Saybrook Democratic Town Committee",
    "Old Saybrook Republican Town Committee",
    "Old Saybrook Republican Women's Club"
  ],
  "Orange": [
    "Orange 2008",
    "Orange 2010",
    "Orange 2014",
    "Orange 2016",
    "Orange 2018",
    "Orange Democratic Town Committee",
    "Orange First, Connecticut First, A Committee",
    "Orange Republican Town Committee"
  ],
  "Oxford": [
    "Oxford Democratic Town Committee",
    "Oxford Republican Town Committee"
  ],
  "Plainfield": [
    "Plainfield Democratic Town Committee",
    "Plainfield Republican Town Committee"
  ],
  "Plainville": [
    "Plainville Democratic Town Committee",
    "Plainville Republican Town Committee"
  ],
  "Plymouth": [
    "Plymouth Democratic Town Committee",
    "Plymouth Republican Town Committee"
  ],
  "Pomfret": [
    "Pomfret Democratic Town Committee",
    "Pomfret Republican Town Committee"
  ],
  "Portland": [
    "Portland Democratic Town Committee",
    "Portland Republican Town Committee"
  ],
  "Preston": [
    "Preston Democratic Town Committee",
    "Preston Hills Committee",
    "Preston Republican Town Committee"
  ],
  "Prospect": [
    "Prospect Democratic Town Committee",
    "Prospect Republican Town Committee"
  ],
  "Putnam": [
    "Putnam Democratic Town Committee",
    "Putnam Republican Town Committee"
  ],
  "Redding": [
    "Redding Democratic Town Committee",
    "Redding Republican Town Committee",
    "Redding-Georgetown Democratic Town Committee",
    "Reddington-Hughes for 66th"
  ],
  "Ridgefield": [
    "Ridgefield Democratic Town Committee",
    "Ridgefield Republican Town Committee"
  ],
  "Rocky Hill": [
    "Rocky Hill Democratic Town Committee",
    "Rocky Hill Republican Town Committee",
    "Rocky Hill Young Democrats"
  ],
  "Roxbury": [
    "Roxbury Democratic Town Committee",
    "Roxbury Republican Town Committee"
  ],
  "Salem": [
    "Salem Democratic Town Committee",
    "Salem Republican Town Committee",
    "Salema4CT"
  ],
  "Salisbury": [
    "Salisbury Democratic Town Committee",
    "Salisbury Republican Town Committee"
  ],
  "Scotland": [
    "Scotland Democratic Town Committee",
    "Scotland Republican Town Committee"
  ],
  "Seymour": [
    "Seymour Democratic Town Committee",
    "Seymour Republican Town Committee"
  ],
  "Sharon": [
    "Sharon Democratic Town Committee",
    "Sharon For A Better CT",
    "Sharon For The 24Th",
    "Sharon Palmer 2016",
    "Sharon Republican Town Committee",
    "Sharon2018"
  ],
  "Shelton": [
    "Shelton Democratic Town Committee",
    "Shelton Republican Town Committee"
  ],
  "Sherman": [
    "Sherman Democratic Town Committee",
    "Sherman Republican Town Committee",
    "sherman66"
  ],
  "Simsbury": [
    "Simsbury - 21St Century",
    "Simsbury Citizens First",
    "Simsbury Democratic Town Committee",
    "Simsbury Republican Town Committee",
    "Simsbury Republican Women's Club",
    "Simsbury/Farmington Valley Republican Women's Club"
  ],
  "Somers": [
    "Somers 2014",
    "Somers Democratic Town Committee",
    "Somers for Senate",
    "Somers For State Senate",
    "Somers PAC",
    "Somers Republican Town Committee"
  ],
  "South Windsor": [
    "South Windsor Democratic Town Committee",
    "South Windsor Federated Democratic Women's Club",
    "South Windsor Republican Town Committee",
    "South Windsor United Community Party"
  ],
  "Southbury": [
    "Southbury Democratic Town Committee",
    "Southbury Democratic Women's Club",
    "Southbury Republican Town Committee"
  ],
  "Southington": [
    "Southington Democratic Town Committee",
    "Southington First",
    "Southington Republican Town Committee"
  ],
  "Sprague": [
    "Sprague Democratic Town Committee",
    "Sprague Republican Town Committee"
  ],
  "Stafford": [
    "Stafford Democratic Town Committee",
    "Stafford for 131",
    "Stafford Republican Town Committee"
  ],
  "Stamford": [
    "Stamford Democratic City Committee",
    "Stamford Firefighters Local 786 PAC",
    "Stamford First",
    "Stamford Green Leadership Committee",
    "Stamford Independent Party Committee",
    "Stamford Police Association Political Action Committee",
    "Stamford Republican Town Committee",
    "Stamford Taxpayers PAC"
  ],
  "Sterling": [
    "Sterling Democratic Town Committee",
    "Sterling Republican Town Committee"
  ],
  "Stonington": [
    "Stonington Borough Democratic Committee",
    "Stonington Borough Republican Committee",
    "Stonington Borough Town Committee of the Forward Party",
    "Stonington Democratic Town Committee",
    "Stonington Republican Town Committee"
  ],
  "Stratford": [
    "Stratford Democratic Town Committee",
    "Stratford Future",
    "Stratford GOP PAC",
    "Stratford Police Union PAC",
    "Stratford Republican Town Committee"
  ],
  "Suffield": [
    "Suffield Democratic Town Committee",
    "Suffield Republican Town Committee"
  ],
  "Thomaston": [
    "Thomaston Democratic Town Committee",
    "Thomaston Republican Town Committee"
  ],
  "Thompson": [
    "Thompson 2012",
    "Thompson Democratic Town Committee",
    "Thompson Republican Town Committee",
    "Thompson-Daniel 2014"
  ],
  "Tolland": [
    "Tolland Democratic Town Committee",
    "Tolland Republican Town Committee"
  ],
  "Torrington": [
    "Torrington Democratic Town Committee",
    "Torrington Republican Town Committee"
  ],
  "Trumbull": [
    "Trumbull Democratic Town Committee",
    "Trumbull Republican Town Committee"
  ],
  "Union": [
    "Union Democratic Town Committee",
    "Union Republican Town Committee"
  ],
  "Vernon": [
    "Vernon Democratic Town Committee",
    "Vernon Education Association Political Action Comm",
    "Vernon Republican Town Committee"
  ],
  "Voluntown": [
    "Voluntown Democratic Town Committee",
    "Voluntown Republican Town Committee"
  ],
  "Wallingford": [
    "Wallingford Democratic Town Committee",
    "Wallingford Republican Town Committee"
  ],
  "Warren": [
    "Warren Democratic Town Committee",
    "Warren Republican Town Committee"
  ],
  "Washington": [
    "Washington / Jefferson Committee",
    "Washington Democratic Town Committee",
    "Washington Republican Town Committee"
  ],
  "Waterbury": [
    "Waterbury Black Democratic Club",
    "Waterbury Democratic Town Committee",
    "Waterbury Labor",
    "Waterbury Leadership PAC",
    "Waterbury Leadership PAC II",
    "Waterbury Police Union Local 1237 COPE",
    "Waterbury Republican Town Committee",
    "Waterbury Teachers Association PAC",
    "Waterbury Working Class Pac",
    "Waterbury Young Democrats"
  ],
  "Waterford": [
    "Waterford Democratic Town Committee",
    "Waterford Green Party Town Committee",
    "Waterford Police Union Political Action Committee",
    "Waterford Republican Town Committee",
    "Waterford Republican Women"
  ],
  "Watertown": [
    "Watertown Republican Town Committee",
    "Watertown-Oakville Democratic Town Committee",
    "Watertown-Oakville Town Committee, Independent Party"
  ],
  "West Hartford": [
    "West Hartford Democratic Town Committee",
    "West Hartford Democrats for Great Schools",
    "West Hartford Police Union PAC",
    "West Hartford Republican Town Committee",
    "West Hartford Republican Women's Club"
  ],
  "West Haven": [
    "West Haven Democratic Town Committee",
    "West Haven Democratic Women's Club",
    "West Haven Independent Party Town Committee",
    "West Haven Republican Town Committee"
  ],
  "Westbrook": [
    "Westbrook Democratic Town Committee",
    "Westbrook Republican Town Committee"
  ],
  "Weston": [
    "Weston Democratic Town Committee",
    "Weston Republican Town Committee"
  ],
  "Westport": [
    "Westport Democratic Town Committee",
    "Westport Republican Town Committee"
  ],
  "Wethersfield": [
    "Wethersfield Democratic Town Committee",
    "Wethersfield Republican Town Committee"
  ],
  "Willington": [
    "Willington Democratic Town Committee",
    "Willington Republican Town Committee",
    "Willington Taxpayers Association"
  ],
  "Wilton": [
    "Wilton Democratic Town Committee",
    "Wilton Republican Town Committee"
  ],
  "Winchester": [
    "Winchester Democratic Town Committee",
    "Winchester Republican Town Committee"
  ],
  "Windham": [
    "Windham Area Landlords Association LLC",
    "Windham Democratic Town Committee",
    "Windham Federation Of Teachers Legislative & Political Action Committee",
    "Windham Green Town Committee",
    "Windham Republican Town Committee",
    "Windham Working Families Town Committee"
  ],
  "Windsor": [
    "Windsor Democratic Town Committee",
    "Windsor Independent Town Committee",
    "Windsor Locks Democratic Town Committee",
    "Windsor Locks Republican Town Committee",
    "Windsor Republican Town Committee"
  ],
  "Windsor Locks": [
    "Windsor Locks Democratic Town Committee",
    "Windsor Locks Republican Town Committee"
  ],
  "Wolcott": [
    "Wolcott Democratic Town Committee",
    "Wolcott GOP Action",
    "Wolcott Republican Town Committee"
  ],
  "Woodbridge": [
    "Woodbridge Democratic Town Committee",
    "Woodbridge Republican Town Committee"
  ],
  "Woodbury": [
    "Woodbury Democratic Town Committee",
    "Woodbury Republican Town Committee"
  ],
  "Woodstock": [
    "Woodstock Democratic Town Committee",
    "Woodstock Republican Town Committee"
  ]
  // __SEEC_ORGS_END__
};
